import { MrDialog } from '@mrhenry/wp--mr-interactive';

declare global {
	interface Window {
		gtag: ( a: string, b: string, c: Record<string, unknown> ) => void,
		Mr: {
			gtagConfigured: boolean
			GA_CONSENT_STATUS: 'GA_CONSENT_STATUS_ACCEPTED' | 'GA_CONSENT_STATUS_REJECTED'
		};
	}
}

function clearGA_Cookies() {
	const domains = [
		'.caw.be',
		'.cawpro.be',
		'.jac.be',
		'.mrhenry.eu',
		'.wp.prv.orb.local',
		'.wp.test',
		// TODO: jac? voor professionals?
	];
	const cookiesToClear = Array.from( document.cookie.toString().matchAll( /(?:^|(?:; ))(_ga[^=]*)/gi ) ).map( ( x ) => {
		return x[1];
	} );

	domains.forEach( ( domain ) => {
		cookiesToClear.forEach( ( cookie ) => {
			document.cookie = `${cookie}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; domain=${domain}; path=/`;
		} );
	} );
}

const GA_CONSENT_STATUS = 'GA_CONSENT_STATUS';
const GA_CONSENT_EXPIRES_AT = 'GA_CONSENT_EXPIRES_AT';

class MrGA_ConsentDialog extends MrDialog {
	override connectedCallback() {
		super.connectedCallback();

		if ( !window.Mr.gtagConfigured ) {
			return;
		}

		requestAnimationFrame( () => {
			if ( !window.Mr.GA_CONSENT_STATUS ) {
				setTimeout( () => {
					this.updateState( 'open' );
				}, 500 );

				return;
			}
		} );
	}

	override async updateState( directive: string ) {
		if ( 'close-and-accept' === directive ) {
			this.accept();

			super.updateState( 'close' );

			return;
		}

		if ( 'close-and-reject' === directive ) {
			this.reject();

			super.updateState( 'close' );

			return;
		}

		super.updateState( directive );
	}

	accept() {
		const duration = 30 * 24 * 3600 * 1000; // 30 days in milliseconds
		const expiration = new Date();
		expiration.setTime( expiration.getTime() + duration );

		try {
			window.gtag( 'consent', 'update', {
				ad_user_data: 'denied',
				ad_personalization: 'denied',
				ad_storage: 'denied',
				analytics_storage: 'granted',
			} );

			window.localStorage.setItem( GA_CONSENT_STATUS, 'GA_CONSENT_STATUS_ACCEPTED' );
			window.localStorage.setItem( GA_CONSENT_EXPIRES_AT, expiration.toString() );
		} catch ( err ) {
			console.log( err );
		}
	}

	reject() {
		const duration = 30 * 24 * 3600 * 1000; // 30 days in milliseconds
		const expiration = new Date();
		expiration.setTime( expiration.getTime() + duration );

		try {
			window.gtag( 'consent', 'update', {
				ad_user_data: 'denied',
				ad_personalization: 'denied',
				ad_storage: 'denied',
				analytics_storage: 'denied',
			} );

			window.localStorage.setItem( GA_CONSENT_STATUS, 'GA_CONSENT_STATUS_REJECTED' );
			window.localStorage.setItem( GA_CONSENT_EXPIRES_AT, expiration.toString() );
			clearGA_Cookies();
		} catch ( err ) {
			console.log( err );
		}
	}

	override firstFocusableElement(): HTMLElement | void {
		return;
	}
}

customElements.define( 'mr-ga-consent-dialog', MrGA_ConsentDialog );

class MrGA_ConsentReset extends HTMLElement {
	async updateState( directive: string ) {
		if ( 'reset' === directive ) {
			try {
				window.gtag( 'consent', 'update', {
					ad_user_data: 'denied',
					ad_personalization: 'denied',
					ad_storage: 'denied',
					analytics_storage: 'denied',
				} );

				window.localStorage.removeItem( GA_CONSENT_STATUS );
				window.localStorage.removeItem( GA_CONSENT_EXPIRES_AT );
				clearGA_Cookies();
			} catch ( err ) {
				console.log( err );
			}
		}
	}
}

customElements.define( 'mr-ga-consent-reset', MrGA_ConsentReset );
